import { useEffect, useState } from "react";
import { Sparkles, ArrowRight } from "lucide-react";

const LAUNCH = new Date("2026-10-01T00:00:00+02:00");

function tick() {
    const d = LAUNCH.getTime() - Date.now();
    if (d <= 0) return null;
    return {
        days: Math.floor(d / 86400000),
        hours: Math.floor((d / 3600000) % 24),
        minutes: Math.floor((d / 60000) % 60),
        seconds: Math.floor((d / 1000) % 60),
    };
}

export default function CountdownStrip({ onCtaClick }) {
    const [t, setT] = useState(tick());
    useEffect(() => {
        const id = setInterval(() => setT(tick()), 1000);
        return () => clearInterval(id);
    }, []);
    if (!t) return null;

    return (
        <div
            className="fixed top-0 inset-x-0 z-[60] bg-gradient-to-r from-slate-900 via-sky-900 to-slate-900 text-white border-b border-sky-500/20"
            data-testid="countdown-strip"
        >
            <div className="absolute inset-0 bg-grid opacity-10 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-4 lg:px-10 h-9 flex items-center justify-between gap-4 text-xs">
                <div className="flex items-center gap-2 min-w-0">
                    <Sparkles className="h-3.5 w-3.5 text-sky-300 shrink-0" />
                    <span className="hidden sm:inline font-semibold text-sky-100">
                        Cleany launcher 1. oktober 2026
                    </span>
                    <span className="sm:hidden font-semibold text-sky-100">Launch:</span>
                </div>
                <div className="flex items-center gap-1.5 font-mono font-bold tabular-nums text-sky-50">
                    <Cell v={t.days} l="d" />
                    <Sep />
                    <Cell v={t.hours} l="t" />
                    <Sep />
                    <Cell v={t.minutes} l="m" />
                    <Sep />
                    <Cell v={t.seconds} l="s" />
                </div>
                <button
                    onClick={onCtaClick}
                    data-testid="countdown-strip-cta"
                    className="hidden md:inline-flex items-center gap-1 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 px-3 h-6 text-[11px] font-semibold transition-colors"
                >
                    Tilmeld <ArrowRight className="h-3 w-3" />
                </button>
            </div>
        </div>
    );
}

function Cell({ v, l }) {
    return (
        <span className="inline-flex items-baseline gap-0.5">
            <span className="text-sky-50">{String(v).padStart(2, "0")}</span>
            <span className="text-[10px] text-sky-300/70 font-normal">{l}</span>
        </span>
    );
}
function Sep() {
    return <span className="text-sky-500/50">·</span>;
}
